/**
 * Cor do badge de furo a partir do texto exibido ("Ovoid", "Mosquete", "Não"...).
 * Com furo: azul (mesmo do status da remessa); sem furo: cinza.
 */
export function getFuroColorClass(furo: string): string {
  if (!furo || furo === "Não") {
    return "bg-neutral-300 text-black";
  }

  return "bg-blue-500 text-white";
}
